import ContactIdMappingListResourcePagingResultModel from '../../generated/types/model/resource/ContactIdMappingListResourcePagingResultModel';

export default class ContactIdMappingListResourcePagingResultViewModel extends ContactIdMappingListResourcePagingResultModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
